import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisMixedChartDataDto,
  IAnalysisMixedChartResponseDto,
  IAnalysisMixedChartResultVo,
  TAnalysisMixedChartDataVo,
} from '../types';

import { isMissingWireArray, pickChartDisplayMeta } from './common';

/** MixedChart · `mixed_chart` 是否无有效数据（与轴类相同：`x_axis_data` + `series_data`）。 */
function isMixedChartWireNoData(
  dto: IAnalysisMixedChartDataDto | null | undefined,
): boolean {
  if (dto == null || typeof dto !== 'object') {
    return true;
  }

  const { x_axis_data: xAxisDataWire, series_data: seriesDataWire } = dto;

  return (
    isMissingWireArray(xAxisDataWire) ||
    isMissingWireArray(seriesDataWire)
  );
}

/** MixedChart · `mixed_chart` 同形透传；`null`/非对象 → `{}`。 */
function normalizeMixedChartData(
  value: IAnalysisMixedChartDataDto | null | undefined,
): TAnalysisMixedChartDataVo {
  if (value == null || typeof value !== 'object') {
    return {};
  }

  return value as TAnalysisMixedChartDataVo;
}

export function transformMixedChartResponseDtoToVo(
  dto: IAnalysisMixedChartResponseDto,
): IAnalysisMixedChartResultVo {
  const { mixed_chart: mixedChartWire } = dto;
  const isNoData = isMixedChartWireNoData(mixedChartWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.MixedChart,
    isNoData,
    ...(isNoData ? {} : { mixedChart: normalizeMixedChartData(mixedChartWire) }),
  };
}
